<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="预警信号告警"
      width="50%"
      class="metro-alert-dialog"
    >
      <template slot="title">
        <div class="metro-alert-dialog-header">
          <img src="../assets/images/alarm-icon.png" alt="预警信号告警" />
          <span>预警信号告警</span>
        </div>
      </template>
      <div
        class="metro-alert-dialog-content"
        v-if="alertForecast && alertForecast.text"
      >
        <div class="metro-alert-dialog-content-item">
          <div class="tip">
            {{ alertForecast.text }}
          </div>
          <div
            class="alarm-icons"
            v-for="item in alertForecast.icons"
            :key="item"
          >
            <img
              :src="require(`@/assets/images/alarmicon/${item}.gif`)"
              alt=""
            />
          </div>
        </div>
      </div>
      <template slot="footer">
        <div class="metro-alert-dialog-footer">
          <div class="metro-alert-dialog-footer-button" @click="handleConfirm">
            确认
          </div>
        </div>
      </template>
    </el-dialog>
    <!-- <audio ref="alarmAudio" class="alarm-audio" :src="require('../assets/alarmSound.wav')" loop preload="auto"></audio> -->
    <audio
      ref="alarmAudio"
      class="alarm-audio"
      src="https://fspms.cn/data/audio/fsSubway.mp3"
      loop
      preload="auto"
    ></audio>
  </div>
</template>
<script>
import { apiData } from "../api/index";

export default {
  props: {
    showMetroAlertDialog: {
      type: Boolean,
      default: false,
    },
    metroAlertForecast: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.showMetroAlertDialog;
      },
      set(val) {
        this.$emit("update:showMetroAlertDialog", val);
      },
    },
    alertForecast() {
      return this.metroAlertForecast;
    },
  },
  watch: {
    showMetroAlertDialog: {
      handler(visible) {
        this.$nextTick(() => {
          if (visible) {
            this.playAlarm();
          } else {
            this.stopAlarm();
          }
        });
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.stopAlarm();
  },
  methods: {
    playAlarm() {
      const audio = this.$refs.alarmAudio;
      if (!audio) {
        return;
      }
      audio.loop = true;
      audio.currentTime = 0;
      const playPromise = audio.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {});
      }
    },
    stopAlarm() {
      const audio = this.$refs.alarmAudio;
      if (!audio) {
        return;
      }
      audio.pause();
      audio.currentTime = 0;
    },
    handleConfirm() {
      apiData.queryMetroAlertAck().then((res) => {
        if (res.status === 200) {
          this.dialogVisible = false;
        }
      });
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped lang="less">
.alarm-audio {
  display: none;
}

@keyframes metro-alert-blink {
  0%,
  100% {
    opacity: 1;
    color: #ffffff;
  }

  50% {
    opacity: 0.35;
    color: #ff6b6b;
  }
}

.metro-alert-dialog {
  z-index: 999;

  /deep/ .el-dialog {
    border: 1px solid #0a4d86 !important;
    width: 35% !important;
    height: auto !important;
    margin-top: 30vh !important;

    .metro-alert-dialog-header {
      display: flex;
      align-items: center;
      gap: 0.62vw;
      font-weight: 600;
      font-size: 1.12vw;
      color: #ffffff;
      animation: metro-alert-blink 1s ease-in-out infinite;

      img {
        width: 1.2vw;
        height: 1.94vh;
        object-fit: contain;
      }
    }

    .el-dialog__header.el-dialog__header {
      // background: url("../assets/images/alarm-header.png") no-repeat center center;
      // background-size: 100% 100%;
      // background: linear-gradient(91deg, rgba(111, 179, 221, 0.02) 0%, #0e73de 50%, rgba(60, 124, 184, 0) 100%);
      background: linear-gradient(
        90deg,
        rgba(111, 179, 221, 0.02),
        #68b1ff 50%,
        rgba(60, 124, 184, 0)
      );
    }

    .el-dialog__body {
      background: #0a4d86;
      background: #2c6aa3;
      // border-bottom-left-radius: 12px;
      // border-bottom-right-radius: 12px;

      .metro-alert-dialog-content {
        display: flex;
        flex-direction: column;

        .metro-alert-dialog-content-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1vw;

          .tip {
            font-size: 0.83vw;
            color: #ffffff;
          }

          .alarm-icons {
            display: flex;
            align-items: center;
            gap: 0.3vw;

            img {
              width: 3.3vw;
              height: 4.21vh;
              object-fit: contain;
              border-radius: 12px;
            }
          }
        }
      }
    }

    .el-dialog__footer {
      background: #0a4d86;
      background: #2c6aa3;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;

      .metro-alert-dialog-footer {
        display: flex;
        justify-content: center;
        align-items: center;

        .metro-alert-dialog-footer-button {
          cursor: pointer;
          background: #ffffff;
          border-radius: 4px;
          opacity: 0.5;
          padding: 1vh 1vw;

          &:hover {
            background: #68b1ff;
            opacity: 0.8;
          }
        }
      }
    }
  }
}
</style>
